import { EthersContractWrapper } from "./contract";
const bridgeAbi = [
    {
        inputs: [],
        name: "depositParameters",
        outputs: [
            {
                internalType: "uint64",
                name: "depositDustThreshold",
                type: "uint64",
            },
            {
                internalType: "uint64",
                name: "depositTreasuryFeeDivisor",
                type: "uint64",
            },
            {
                internalType: "uint64",
                name: "depositTxMaxFee",
                type: "uint64",
            },
            {
                internalType: "uint32",
                name: "depositRevealAheadPeriod",
                type: "uint32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "redemptionParameters",
        outputs: [
            {
                internalType: "uint64",
                name: "redemptionDustThreshold",
                type: "uint64",
            },
            {
                internalType: "uint64",
                name: "redemptionTreasuryFeeDivisor",
                type: "uint64",
            },
            {
                internalType: "uint64",
                name: "redemptionTxMaxFee",
                type: "uint64",
            },
            {
                internalType: "uint64",
                name: "redemptionTxMaxTotalFee",
                type: "uint64",
            },
            {
                internalType: "uint32",
                name: "redemptionTimeout",
                type: "uint32",
            },
            {
                internalType: "uint96",
                name: "redemptionTimeoutSlashingAmount",
                type: "uint96",
            },
            {
                internalType: "uint32",
                name: "redemptionTimeoutNotifierRewardMultiplier",
                type: "uint32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
];
export default class TbtcBridge extends EthersContractWrapper {
    constructor(runner, address) {
        super({
            address,
            runner,
        }, {
            address,
            abi: bridgeAbi,
        });
    }
    async depositParameters() {
        return (await this.instance.depositParameters());
    }
    async redemptionParameters() {
        return (await this.instance.redemptionParameters());
    }
}
//# sourceMappingURL=tbtc-bridge.js.map